<mat-card (click)="closeAllMenuContectuelle()">
    <mat-card-header class="titreFrm">
        <mat-card-title>ACTION {{titre}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
       
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        
        <!-------------------- bouton -->
        <div class="btn1">
            <div *ngIf="index > 0" class="button-row">
                <button (click)="suivantPresedent(-1)" mat-raised-button class="colorGreen">
                    <mat-icon>navigate_before</mat-icon>
                    &Eacute;tape précédente
                </button>
            </div>
            <!-- <div class="button-row">
                <button  *ngIf="!disabled"  [disabled]="disabled" (click)="retourListeAction()" mat-raised-button class="colorGreen">
                    <mat-icon>format_list_bulleted</mat-icon>Retour au liste
                </button>
            </div> -->
            <div *ngIf="!disabled && index == 4 && typeAction == '0'" class="button-row">
                <button mat-raised-button class="colorGreen">
                    <mat-icon>edit</mat-icon>
                    Édition contrats / Conventions</button>
            </div>
            <div *ngIf="(index < 5 && (typeAction == '0' || typeAction == '2')) || (index < 2 && typeAction != '0')" class="button-row">
                <button (click)="suivantPresedent(1)" mat-raised-button class="colorGreen">
                    &Eacute;tape suivante
                <mat-icon>navigate_next</mat-icon>
                </button>
            </div>
        </div>
         <!--------------------fin bouton -->
        <mat-tab-group #tabGroupe [(selectedIndex)]="index" (animationDone)="animationDone()" (selectedTabChange)="tabChanged($event)"
            (focusChange)="setOldIndex($event)">
            <!-------------------- Informations action------------>
            <mat-tab label="Informations action">
                <form class="example-form" #informationAction="ngForm">
                    <input type="submit" style="display: none;" id="btnInformationAction" />   
                    <br>
                    <div class="displayFlex">
                        <!-------------------- detail Action ------------>
                        <mat-card class="cardInformaton width100 displayFlex">
                            <mat-form-field     appearance="outline"  style="width: 70px;">
                                <mat-label>Num&eacute;ro</mat-label>
                                <input disabled matInput name="avtAction_Code" [(ngModel)]="action.avtAction_Code" placeholder="Num&eacute;ro"
                                    disabled>
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  style="width: 170px;">
                                <mat-label>Type action</mat-label>
                                <mat-select [disabled]="disabled" name="avtAction_Type" #avtAction_Type="ngModel"
                                    [(ngModel)]="action.avtAction_Type" placeholder="Type action" required>
                                    <mat-option *ngFor="let typeAction of listeTypeAction" [value]="typeAction.avtParamAction_Code">
                                        {{typeAction.avtParamAction_Description}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  style="width: 130px;">
                                <mat-label>Date début</mat-label>
                                <input (dateChange)="dateActionChange('DATEDEBUT')" [disabled]="disabled" matInput name="avtAction_dateDeb"
                                    #avtAction_dateDeb="ngModel" [(ngModel)]="action.avtAction_dateDeb" [matDatepicker]="picker1"
                                    placeholder="Date début" required>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  style="width: 130px;">
                                <mat-label>Date fin</mat-label>
                                <input (dateChange)="dateActionChange('DATEFIN')" [disabled]="disabled" matInput name="avtAction_dateFin"
                                    #avtAction_dateFin="ngModel" [(ngModel)]="action.avtAction_dateFin" [matDatepicker]="picker2"
                                    placeholder="Date fin" required>
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  style="width: 250px;">
                                <mat-label>Intitul&eacute;</mat-label>
                                <input [disabled]="disabled" matInput name="avtAction_Intitule" #avtAction_Intitule="ngModel"
                                    [(ngModel)]="action.avtAction_Intitule" placeholder="Intitul&eacute;" required>
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  *ngIf="typeAction == '0'" style="width: 300px;">
                                <mat-label>Cursus</mat-label>
                                <mat-select [disabled]="disabled" name="Cursus_Code" #Cursus_Code="ngModel" (selectionChange)="onCursusActionChange()"
                                    [(ngModel)]="action.Cursus_Code" placeholder="Cursus" required>
                                    <mat-option *ngFor="let cursus of listeCursus" [value]="cursus.Cursus_Code">
                                        {{cursus.Cursus_Titre}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <app-recherche
                                #clientComponent
                                *ngIf="typeAction == '2'" 
                                [style]="{'width' : '170px','margin-right': '10px'}"
                                [disabled]="disabled" 
                                [api]="generalService.api" 
                                [numColonneToShow]="1" 
                                [numColonneToReturn]="0" 
                                (ChampEnter)="blurClient($event)"
                                recherche="TierType" 
                                [param]="'1'" 
                                name="name_1" 
                                placeholder="Client" >
                            </app-recherche>
                            <app-recherche 
                                #collaborateurComponent
                                *ngIf="typeAction == '2'" 
                                [style]="{'width' : '170px'}"
                                [disabled]="disabled" 
                                [api]="generalService.api" 
                                [numColonneToShow]="1" 
                                [numColonneToReturn]="0" 
                                recherche="avtAcollaborateur" 
                                [param]="'0'" 
                                name="name_2" 
                                placeholder="Manageur" 
                                (ChampEnter)="blurCollaborateur($event)">
                            </app-recherche>
                        </mat-card>
                        <!-------------------- Plage horaire ------------>
                        <mat-card class="cardInformaton">
                            <mat-card-content>
                                <form #plageHaurere="ngForm">
                                    <h4>Plage horaire</h4>
                                    <div class="displayFlex">
                                        <div>
                                            <mat-checkbox [disabled]="disabled" name="Matin_Checked" [(ngModel)]="MatinChecked" (change)="onMatinChecked()">
                                                <h5>Matin</h5>
                                            </mat-checkbox><br>
                                            <mat-form-field     appearance="outline"  style="width: 70px;">
                                                <mat-label>H.D&eacute;but</mat-label>
                                                <input [disabled]="disabled || !MatinChecked" matInput name="avtAction_heureDebAM" #avt_Action_heureDebAM
                                                [matAutocomplete]="auto1" [(ngModel)]="action.avtAction_heureDebAM"
                                                (blur)="ActionHeureAMBlur($event,'this.action.avtAction_heureDebAM')" placeholder="H.D&eacute;but"  [required]="MatinChecked"
                                                (input)="timeAMchange($event)">
                                                <mat-autocomplete #auto1="matAutocomplete">
                                                <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>

                                            <mat-form-field     appearance="outline"  style="width: 70px;">
                                                <mat-label>H.Fin</mat-label>
                                                <input [disabled]="disabled || !MatinChecked" matInput name="avtAction_heureFinAM" #avt_Action_heureFinAM
                                                [matAutocomplete]="auto2" [(ngModel)]="action.avtAction_heureFinAM"
                                                (blur)="ActionHeureAMBlur($event,'this.action.avtAction_heureFinAM')" placeholder="H.Fin"  [required]="MatinChecked"
                                                (input)="timeAMchange($event)">
                                                <mat-autocomplete #auto2="matAutocomplete">
                                                <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                
                                        <div>
                                            <mat-checkbox style="margin-left: -50px;" [disabled]="disabled" name="ApMidi_Checked" [(ngModel)]="ApMidiChecked" (change)="onApMidiChecked()">
                                                <h5>Apr&egrave;s midi</h5>
                                            </mat-checkbox>
                                            <br>
                                            <mat-form-field     appearance="outline"  style="width: 70px;">
                                                <mat-label>H.D&eacute;but</mat-label>
                                                <input [disabled]="disabled || !ApMidiChecked" matInput name="avtAction_heureDebPM"
                                                [matAutocomplete]="auto3" [(ngModel)]="action.avtAction_heureDebPM"
                                                (blur)="ActionHeurePMBlur($event,'this.avtAction_heureDebPM')" placeholder="H.D&eacute;but"  [required]="ApMidiChecked"
                                                (input)="timePMchange($event)">
                                                <mat-autocomplete #auto3="matAutocomplete">
                                                <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                            <mat-form-field     appearance="outline"  style="width: 70px;">
                                                <mat-label>H.Fin</mat-label>
                                                <input [disabled]="disabled || !ApMidiChecked" matInput name="avtAction_heureFinPM"
                                                [matAutocomplete]="auto4" [(ngModel)]="action.avtAction_heureFinPM"
                                                (blur)="ActionHeurePMBlur($event,'this.avtAction_heureFinPM')" placeholder="H.Fin"  [required]="ApMidiChecked"
                                                (input)="timePMchange($event)">
                                                <mat-autocomplete #auto4="matAutocomplete">
                                                <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                                    {{option}}
                                                </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>  
                                            <button  *ngIf="!disabled && typeAction == '2'"  [disabled]="disabled" (click)="appliquerHeurJour(plageHaurere)" mat-raised-button class="colorGreen">
                                                <mat-icon>settings</mat-icon>Appliquer
                                            </button>                              
                                        </div> 
                                    </div>    
                                </form>
                                <div *ngIf="typeAction == '2'" style="width: 500px;">
                                    <app-avt-listes 
                                        heightTable="500"
                                        [matSortDisabled]="true"
                                        [api]="generalService.api" 
                                        #listeHeurSemaineComponent
                                        [showFilter]="false" 
                                        [displayedColumnsBrut]="columnHeureSemaine" 
                                        (outputAction)="outputActionListeHeurSemaineComponent($event)">
                                    </app-avt-listes>                                
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <!--------------------card Apprenant Groupe ou liste collaborateur------------>
                        <mat-card class="cardInformaton">
                            <div style="margin-top: -15px;">
                                <div *ngIf="typeAction == '0'">
                                    <h4>Modalités</h4>
                                    <mat-radio-group (change)="radioModalitesChange($event)" name="modaliterFormation" [(ngModel)]="action.avtAction_ModFormation" required>
                                        <mat-radio-button *ngFor="let modaliter of listeModaliter"  [disabled]="disabled" [value]="modaliter.DiverSys_Index">{{modaliter.DiverSys_Titre}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div class="displayFlex">
                                    
                                    <div class="liste-apprenant">
                                        <div class="titre-liste-apprenant">
                                            <span>Liste {{ecrant}}</span>
                                        </div>
                                        <div style="width : 235px">
                                            <app-avt-listes [showFilter]="true" #listeApprenantsComponen [multipleSelect]="false" 
                                                [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsApprenants" ></app-avt-listes>
                                        </div>
                                    </div>
                                    <div class="carClass">
                                        <!-- <mat-icon>undo</mat-icon><mat-icon>redo</mat-icon> -->
                                        <button *ngIf="!disabled" [disabled]="disabled" style="margin-bottom: 5px;" (click)="addApprenat()"  mat-raised-button class="colorBlue">
                                            <mat-icon>arrow_forward</mat-icon>
                                        </button><br>
                                        <button *ngIf="!disabled" [disabled]="disabled" (click)="removeApprenat()"  mat-raised-button class="colorBlue">
                                            <mat-icon>arrow_back</mat-icon>
                                        </button>
                                    </div>

                                    <div [ngClass]="typeAction=='1' || typeAction=='2' ? 'liste-apprenant' : 'margin-top-10'">
                                        <div *ngIf="typeAction=='0'">
                                             <span class="titre-liste-apprenant">Groupe</span>
                                            <mat-form-field     appearance="outline"   style="width: 100px;" class="heightInput">
                                                <mat-label>Nom groupe</mat-label>
                                                <input [disabled]="disabled" placeholder="Nom groupe" matInput name="avtAction_Groupe" #avtAction_Groupe="ngModel" [(ngModel)]="action.avtAction_Groupe" required>
                                            </mat-form-field>  
                                        </div>
                                        <div *ngIf="typeAction =='1' || typeAction =='2'"  class="titre-liste-apprenant">
                                            Collaborateurs Action
                                        </div>  
                                        <div class="divMatSelectionList" style="width : 235px">
                                            <app-avt-listes [showFilter]="true" #listeApprenantGroupeComponen [multipleSelect]="false"  
                                                [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsApprenants"></app-avt-listes>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </mat-card>
                    </div>
                </form>
            </mat-tab>
            <!-------------------- Calendrier calmoi action ------------>
            <mat-tab label="Calendrier action">
                <br>
                <div class="displayFlex">
                    <div >
                         <mat-card *ngIf="typeAction == '0'" class="cardInformaton" >
                        <!-- ----------Type présence---------- -->
                            <h5>( F  : Facturable )</h5>
                            <h5>( P  : Planifiable )</h5>
                            <h5>( I  : Inclus dans l'heure de cours )</h5>
                            <samp style="font-size: 15px;font-weight: bold;">
                                <span matTooltip="Facturable" style="margin-left: 5px;">F</span>
                                <span matTooltip="Planifiable" style="margin-left: 15px;">P</span>
                                <span matTooltip="Inclus dans l'heure de cours" style="margin-left: 13px;">I</span>
                                <span style="margin-left: 13px;">Type présence</span>
                            </samp>
                           
                            <br>
                            <mat-radio-group (change)="typePresenceActionChange(false)" name="typePresence" [(ngModel)]="selectedTypePresence">
                                <div *ngFor="let type of typePresenceAction" >
                                    <mat-checkbox [disabled]="selectedTypePresence != type.avtActionType_Id || disabled" matTooltip="Facturable" [(ngModel)]="type.avtActionType_Facturable"  style="margin-right: 5px;"></mat-checkbox>
                                    <mat-checkbox [disabled]="selectedTypePresence != type.avtActionType_Id || disabled" matTooltip="Planifiable" [(ngModel)]="type.avtActionType_Planifiable"  style="margin-right: 5px;"></mat-checkbox>
                                    <mat-checkbox [disabled]="selectedTypePresence != type.avtActionType_Id || disabled" matTooltip="Inclus dans l'heure de cours" [(ngModel)]="type.avtActionType_InclusHeureCours"  style="margin-right: 5px;"></mat-checkbox>
                                    <mat-radio-button [value]="type.avtActionType_Id">{{type.DiverSys_Titre}}</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </mat-card>
                        <mat-card class="cardInformaton">
                            <form class="example-form" #intervaleHeureTypePresence="ngForm">
                                <div *ngIf="typeAction == '2'">
                                    <mat-form-field     appearance="outline"  style="width: 160px;">
                                        <mat-label>Intitul&eacute;</mat-label>
                                        <input [disabled]="disabled" matInput name="actiIntitule" #actIntitule="ngModel"
                                            [(ngModel)]="actionDIntitule" placeholder="Intitul&eacute;" required>
                                    </mat-form-field>
                                    <br>
                                    <app-recherche 
                                        #collaborateurCalendrierActionComponent
                                        [required] = "true"
                                        [style]="{'width' : '160px'}"
                                        [disabled]="disabled" 
                                        [api]="generalService.api" 
                                        [numColonneToShow]="1" 
                                        [numColonneToReturn]="0" 
                                        (ChampEnter)="blurCollaborateurCalendrierAction($event)"
                                        recherche="avtAcollaborateur" 
                                        [param]="'0'" 
                                        name="name_2" 
                                        placeholder="Collaborateurs" >
                                    </app-recherche>
                                    <br>
                                    <mat-form-field     appearance="outline"  style="width: 160px;">
                                        <mat-label>Type action</mat-label>
                                        <mat-select [disabled]="disabled" name="actioType" #actioType="ngModel"
                                            [(ngModel)]="typeActionD" placeholder="Type action" required>
                                            <mat-option *ngFor="let typeAction of listeTypeAction" [value]="typeAction.avtParamAction_Code">
                                                {{typeAction.avtParamAction_Description}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            <!-- ----------intervale heure--------- -->
                                <input type="submit" style="display: none;" id="btnIntervaleHeureTypePresence" />  
                                <!-- Matin -->
                                <div style="margin-right: 10px">
                                    <mat-checkbox [disabled]="disabled" name="MatinChecked" [(ngModel)]="MatinTypePresenceChecked" (change)="onMatinTypePresenceChecked()">
                                        <h5>Matin</h5>
                                    </mat-checkbox>
                                    <br>
                                    <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                                        <mat-label>H.D&eacute;but</mat-label>
                                        <input [disabled]="disabled || !MatinTypePresenceChecked" matInput name="typePresence_HeureDebAM"
                                          [matAutocomplete]="auto5" [(ngModel)]="typePresenceHeureDebAM"
                                          (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureDebAM')" placeholder="H.D&eacute;but"  [required]="MatinTypePresenceChecked"
                                          (input)="timeAMchange($event)">
                                        <mat-autocomplete #auto5="matAutocomplete">
                                          <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <mat-form-field     appearance="outline"  style="width: 70px;">
                                        <mat-label>H.Fin</mat-label>
                                        <input [disabled]="disabled || !MatinTypePresenceChecked" matInput name="typePresence_HeureFinAM"
                                          [matAutocomplete]="auto6" [(ngModel)]="typePresenceHeureFinAM"
                                          (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureFinAM')" placeholder="H.Fin"  [required]="MatinTypePresenceChecked"
                                          (input)="timeAMchange($event)">
                                        <mat-autocomplete #auto6="matAutocomplete">
                                          <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <!-- -----apres midi -->
                                <div>
                                    <mat-checkbox [disabled]="disabled" name="ApMidiCheckedx" [(ngModel)]="ApMidiTypePresenceChecked" (change)="onApMidiTypePresenceChecked()">
                                        <h5>Apr&egrave;s midi</h5>
                                    </mat-checkbox>
                                    <br>
                                    <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                                        <mat-label>H.D&eacute;but</mat-label>
                                        <input [disabled]="disabled || !ApMidiTypePresenceChecked" matInput name="typePresence_HeureDebPM"
                                          [matAutocomplete]="auto7" [(ngModel)]="typePresenceHeureDebPM"
                                          (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureDebPM')" placeholder="H.D&eacute;but"  [required]="ApMidiTypePresenceChecked"
                                          (input)="timePMchange($event)">
                                        <mat-autocomplete #auto7="matAutocomplete">
                                          <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <mat-form-field     appearance="outline"  style="width: 70px;">
                                        <mat-label>H.Fin</mat-label>
                                        <input [disabled]="disabled || !ApMidiTypePresenceChecked" matInput name="typePresence_HeureFinPM"
                                          [matAutocomplete]="auto8" [(ngModel)]="typePresenceHeureFinPM"
                                          (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureFinPM')" placeholder="H.Fin"  [required]="ApMidiTypePresenceChecked"
                                          (input)="timePMchange($event)">
                                        <mat-autocomplete #auto8="matAutocomplete">
                                          <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </div>
                                <!-- <div class="button-row">
                                    <button  [disabled]="disabled" (click)="calculerNbrHeurTypePresenceEndSetDataSourceListeTypePresenceComponen()"  mat-raised-button class="colorGreen">
                                        <mat-icon>settings</mat-icon>
                                        Calculer Nbr heure
                                    </button>
                                </div> -->
                            </form>

                        </mat-card>
                    </div>   

                    <!-- ----------fin Type présence--------- -->
                    <!-- ----------- calendrier calmois  ------------->
                    <mat-card class="cardInformaton" style="width: 660px;">
                        <!-- ne pas supprimer la boucle ngFor c pour obliger angular recharger le calendrier -->
                        <mat-card-content *ngFor="let a of randomList">
                            <app-calmois #calmoisComponens  class="calendar" [listeCal]="listeCal" (contextmenu)="openMenuContectuelleCalmois($event)">
                            </app-calmois>
                        </mat-card-content>
                    </mat-card>
                    <!-- -----------Fin calendar ------------->
                    <div *ngIf="typeAction == '0'" style="width: 280px;">
                        <app-avt-listes [showFilter]="false" #listeTypePresenceComponen 
                            [heightTable]="'400'" [dataSourceBrut]="typePresenceAction" [displayedColumnsBrut]="columnsTypePresence">
                         </app-avt-listes>
                    </div>
                    <div *ngIf="typeAction == '1' || typeAction =='2'" style="width: 250px;">
                        <app-avt-listes [showFilter]="true" #listeCollaborateurComponen [multipleSelect]="false" 
                            [heightTable]="'400'" [dataSourceBrut]="[]" [displayedColumnsBrut]="columnsCollaborateur"></app-avt-listes>
                    </div>
                </div>
            </mat-tab>
            <!-------------------- Planification action  ------------>
            <mat-tab *ngIf="typeAction == '0'" label="Planification action">
                    <mat-card class="cardInformaton" style="height: auto;">
                        <mat-card-content>
                            <div class="displayFlex">
                                <form class="example-form" #informationActionD="ngForm">
                                    <input type="submit" style="display: none;" id="btnInformationActionD">
                                    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px;" class="heightInput">
                                        <mat-select [disabled]="disabled" name="Matiere_Code" #Matiere_Code="ngModel" 
                                            [(ngModel)]="selectedMatiereCursus.Matiere_Code" 
                                            (selectionChange)="onMatiereChange($event,'selectedMatiereCursus')"
                                            placeholder="Matière"  required>
                                            <mat-option *ngFor="let mat of listeMatiereCursus" [value]="mat.Matiere_Code">
                                            {{mat.matiereName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-checkbox [disabled]="disabled" (change)="ressourcesHumainesCheckedChange()" [(ngModel)]="ressourcesHumainesChecked" class="checkbox-ressources-humaines" name="ressources_HumainesChecked"></mat-checkbox>
                                    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px" class="heightInput" (click)="verifierExistanceSelectedMatiereCursus()">
                                        <mat-label>Ressources Formatrices</mat-label>
                                        <mat-select  [disabled]="disabled" name="PersoMatricule" #PersoMatricule="ngModel" 
                                            
                                            [(ngModel)]="Perso_MatriculeSelectedRessourceHumaines" 
                                            (selectionChange)="onRessourcesHumainesChange()"
                                            placeholder="Ressources Formatrices"  required>
                                            <mat-option *ngFor="let ressource of listeRessourcesHumaines" [value]="ressource.Perso_Matricule">
                                            {{ressource.Perso_Nom}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                
                                    <mat-checkbox  [disabled]="disabled"(change)="salleAtelierCheckedChange()" [(ngModel)]="salleAtelierChecked" class="checkbox-salle-atelier" name="salle_AtelierChecked"></mat-checkbox>
                                    <!-- <button (click)="openListeSalle()" mat-raised-button class="colorBlue">
                                        <mat-icon>mouse</mat-icon>
                                        Choisir salle/atelier
                                    </button>
                                    <mat-form-field     appearance="outline"  [ngStyle]="{'width':'200px','margin-left':'10px'}">
                                        <input disabled matInput name="salleAtelier" [ngModel]="selectedSalle.Machine_Lib" placeholder="Salle/Atelier">
                                    </mat-form-field> -->
                                    
                                    <mat-form-field     appearance="outline"  style="width: 300px;margin-right: 10px" class="heightInput">
                                        <mat-label>Salle/Atelier</mat-label>
                                        <mat-select [disabled]="disabled" name="sal" #sal="ngModel" 
                                            [(ngModel)]="Machine_SelectedSalle" 
                                            (selectionChange)="onSalleChange()"
                                            placeholder="Salle/Atelier"  required>
                                            <mat-optgroup *ngFor="let group of listeSallesForMatSelect" [label]="group.type">
                                                <mat-option *ngFor="let salle of group.detail" [value]="salle.Machine_Code">
                                                    {{salle.Batiment}}&nbsp;
                                                    <b>N°:</b>{{salle.numPort}}&nbsp;                                                    
                                                    <b>Etage:</b>{{salle.etage}}
                                                </mat-option>
                                            </mat-optgroup>
                                            <!-- <mat-option *ngFor="let salle of listeSalles" [value]="salle.Machine_Code">
                                                <b>Type:</b>{{salle.type}}&nbsp; 
                                                <b>Port:</b>{{salle.numPort}}&nbsp;
                                                <b>Batiment:</b>{{salle.Batiment}}&nbsp;
                                                <b>Etage:</b>{{salle.etage}}&nbsp;
                                            </mat-option> -->
                                            </mat-select>
                                    </mat-form-field>

                                                            
                                </form>    
                                <!-- filter calendar -->
                                <!-- filter date -->
                                <div>
                                    <div class="displayFlex">
                                        <h3 style="margin-right: 30px;">Mois: &nbsp;</h3>
                                        <div class="filter-date">
                                            <div class="display-flex">
                                                <div *ngFor="let month of listMonth;let i = index" [id]="'month_'+i" (click)="setListWeek(month,i)" class="rectengle-arrendi" >
                                                    &nbsp;{{(((month.monthId + 1) < 10) ? "0"+(month.monthId + 1) : (month.monthId + 1)) + "-" + (month.year - 2000)}}&nbsp;
                                                </div>                                        
                                            </div>                                        
                                        </div>                                        
                                    </div>
                                    <div class="displayFlex">
                                        <h3>Semaines: &nbsp;</h3>
                                        <div class="filter-date">
                                            <div class="display-flex">
                                                <div (click)="showDetaille(week,week.enable,k)" [id]="'week_'+k" *ngFor="let week of listWeek;let k= index" class="rectengle-arrendi">
                                                    &nbsp;<span>S{{week.colSpan}}</span>&nbsp;&nbsp;<span style="font-size: 10px">{{week.monthName}}</span>&nbsp;
                                                </div>                                        
                                            </div>                                            
                                        </div>

                                    </div>    

                                </div>

                            </div>

                            <div class="displayFlex" style="margin-bottom: 10px;">
                                <!-------------- calendar action ------------------->
                                
                                <div class="" style="width: 800px;margin-right: 10px;">
                                    <app-calendar
                                        #calendarActionComponent
                                        *ngIf="showCalendarAction && paramHeure != undefined"
                                        [showHeader]="false"
                                        [events]="eventsCalandar"
                                        [selectable]="!disabled" 
                                        [editable]="!disabled"
                                        [paramHeure]="paramHeureCalendar" 
                                        [intervale]=7 
                                        [date_Fin]="avtActionDateFin" 
                                        [date_Debut]="avtActionDateDeb" 
                                        [defaultDate]="avtActionDateDeb" 
                                        (actionCalendar)="actionCalendar($event)"
                                        (contextmenu)="openMenuContectuelleAction($event)" 
                                        >

                                    </app-calendar>
                                    <!-- <app-show-calendar #calendarActionComponent
                                        *ngIf="showCalendarAction && paramHeure != undefined"
                                        [showHeader]="false"
                                        [events]="eventsCalandar"
                                        [selectable]="!disabled" 
                                        [editable]="!disabled" 
                                        [paramHeure]="paramHeureCalendar" 
                                        [intervale]=7 
                                        [date_Fin]="avtActionDateFin" 
                                        [date_Debut]="avtActionDateDeb" 
                                        [defaultDate]="avtActionDateDeb"
                                        (actionCalendar)="actionCalendar($event)"
                                        (contextmenu)="openMenuContectuelleAction($event)" >
                                    </app-show-calendar> -->
                                </div>
                                <div style="width: 400px;margin-top: 20px;">
                                    <app-avt-listes [showFilter]="false" #listeMatiereComponen
                                    [heightTable]="'400'" [dataSourceBrut]="dataSourceMatiere" [displayedColumnsBrut]="columnsMatiere">
                                </app-avt-listes>
                                </div>
                                
                                
                            </div>
                      
                        </mat-card-content>
                    </mat-card>
            </mat-tab>
            <!----------------------  devis -------------->
            <mat-tab *ngIf="typeAction == '2'" label="Devis">
                    <mat-card class="mat-form-field-margin">
                        
                        <app-avt-listes
                            #listeDevisComponen
                            [showFilter]="false"
                            [listBtn]="listBtnListeDevis"
                            [heightTable]="'400'" 
                            [dataSourceBrut]="[]" 
                            [displayedColumnsBrut]="columnsListeDocument"
                            (btnTable)="clickBtnHeatListeDocument($event,'3')">
                        </app-avt-listes>
                            <!-- <app-avt-listes
                                #newDocumentComponen 
                                [showFilter]="false"
                                [listBtn]="[]"
                                [heightTable]="'400'" 
                                [dataSourceBrut]="[getNewRowDevis()]" 
                                [displayedColumnsBrut]="columnsNewDocument"
                                (outputAction)="outputActionNewDocument($event)">
                            </app-avt-listes>                         -->
                    </mat-card>
            </mat-tab>
            <!----------------------  Conventions / Contrats -------------->
            <mat-tab *ngIf="typeAction == '0'"  label="Conventions / Contrats">
                <mat-card class="cardInformaton">
                        <mat-card-content>
                            <app-avt-listes [showFilter]="false" #listeContrat
                                [heightTable]="'300'" [dataSourceBrut]="dataSourceContrat" [displayedColumnsBrut]="columnsContrat">
                            </app-avt-listes>
                        </mat-card-content>
                    </mat-card>
            </mat-tab>
            <!----------------------  bon de commande -------------->
            <mat-tab *ngIf="typeAction == '2' || typeAction == '0'" label="Bon de commande">
                <br>
                <div class="btn1">
                    <div [ngStyle]="typeAction == '0'? {'width' : '40%', 'min-width': '400px'} : {'width' : '100%'}">
                        <mat-card class="cardInformaton" >
                            <mat-card-content>
                                <app-avt-listes 
                                    #listeBCComponen
                                    [showFilter]="false" 
                                    [heightTable]="'200'" 
                                    [dataSourceBrut]="[]" 
                                    [displayedColumnsBrut]="columnsBonCommande"
                                    [listBtn]="listBtnBC" 
                                    (btnTable)="clickBtnBonCommande($event)">
                                </app-avt-listes>
                            </mat-card-content>
                        </mat-card>                        
                    </div>
                    <div *ngIf="typeAction == '0'"  style="width: calc(60% - 15px);min-width: 500px;">
                        <mat-card class="cardInformaton">
                            <mat-card-content>
                                <h4>Liste des financiers par apprenants</h4>
                                <table mat-table style="width: 100%;" [dataSource]="listeFinanceurByApprenant" multiTemplateDataRows>
                                    <ng-container matColumnDef="colExp">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="button-row">
                                        <button mat-icon-button color="primary">
                                            <mat-icon (click)="toggleRowListeFinanceurByApprenant(element,$event)" aria-label="Example icon-button with a heart icon">add</mat-icon>
                                        </button>
                                        </div>
                                    </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Perso_Nom">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Nom Apprenant
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.Perso_Nom}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Perso_Prenom">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Prénom Apprenant
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.Perso_Prenom}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="Tiers_NomPublic">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Sté de l'apprenant
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element.Tiers_NomPublic}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="expandedDetail">
                                        <td *matCellDef="let element" [attr.colspan]="columnsListeFinanceurByApprenant.length">
                                        <div>
                                            <table style="width: 100%;" mat-table [dataSource]="element.detail" class="mat-elevation-z8">
                                                <ng-container matColumnDef="Tiers_NomPublic">
                                                    <th mat-header-cell *matHeaderCellDef> Financeur </th>
                                                    <td mat-cell *matCellDef="let d">
                                                        {{d.Tiers_NomPublic}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="avtCursusFinance_NbrHeure">
                                                    <th mat-header-cell *matHeaderCellDef> N.Heur </th>
                                                    <td mat-cell *matCellDef="let d">
                                                        {{d.avtCursusFinance_NbrHeure}}
                                                    </td>
                                                </ng-container>
                                            <ng-container matColumnDef="ModePaiement">
                                                <th mat-header-cell *matHeaderCellDef> Mode de paiement </th>
                                                <td mat-cell *matCellDef="let d">
                                                    <mat-form-field     appearance="outline"  style="width: 153px;">
                                                        
                                                        <mat-select [disabled]="disabled" name="avtCursusFinance_ModePaiement" #avtCursusFinance_ModePaiement="ngModel" [(ngModel)]="d.avtCursusFinance_ModePaiement" required>
                                                        <mat-option *ngFor="let ModePaiement of listeModePaiement" [value]="ModePaiement.DiverSys_Index">
                                                            {{ModePaiement.DiverSys_Titre}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="Tva">
                                                <th mat-header-cell *matHeaderCellDef> TVA </th>                                                               
                                                <td mat-cell *matCellDef="let d">
                                                    <mat-form-field     appearance="outline"  style="width: 165px;">
                                                        <mat-select [disabled]="disabled" name="avtCursusFinance_Tva" #avtCursusFinance_Tva="ngModel" [(ngModel)]="d.avtCursusFinance_Tva" required>
                                                        <mat-option *ngFor="let ModePaiement of listeModePaiement" [value]="ModePaiement.DiverSys_Index">
                                                            {{ModePaiement.DiverSys_Titre}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="ModeFacturation">
                                                <th mat-header-cell *matHeaderCellDef> Mode Facturation </th>
                                                <td mat-cell *matCellDef="let d">
                                                    <mat-form-field     appearance="outline"  style="width: 165px;">
                                                        <mat-select [disabled]="disabled" name="avtCursusFinance_ModeFacturation" #avtCursusFinance_ModeFacturation="ngModel" [(ngModel)]="d.avtCursusFinance_ModeFacturation" required>
                                                            <mat-option *ngFor="let ModeFacturation of listeModeFacturation" [value]="ModeFacturation.DiverSys_Index">
                                                                {{ModeFacturation.DiverSys_Titre}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="DelaiReglement">
                                                <th mat-header-cell *matHeaderCellDef> Délai règlement </th>
                                                <td mat-cell *matCellDef="let d">
                                                    <mat-form-field     appearance="outline"  style="width: 132px;">
                                                        <mat-select [disabled]="disabled" name="avtCursusFinance_DelaiReglement" #avtCursusFinance_DelaiReglement="ngModel" [(ngModel)]="d.avtCursusFinance_DelaiReglement" required>
                                                            <mat-option *ngFor="let DelaiReglement of listeDelaiReglement" [value]="DelaiReglement.DiverSys_Index">
                                                                {{DelaiReglement.DiverSys_Titre}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </td>
                                            </ng-container>                
                                            <tr mat-header-row *matHeaderRowDef="columnsListeDetailFinanceurByApprenant"></tr>
                                            <tr mat-row *matRowDef="let row; columns: columnsListeDetailFinanceurByApprenant;"></tr>
                                            </table>
                                        </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="columnsListeFinanceurByApprenant"></tr>
                                    <tr mat-row *matRowDef="let element; columns: columnsListeFinanceurByApprenant" [id]="'trTable'+element.Perso_Matricule" (click)="selectRowListeFinanceurByApprenant($event,element,'trTable'+element.Perso_Matricule)" [class.example-expanded-row]="false"></tr>
                                    <tr mat-row *matRowDef="let row columns: ['expandedDetail'];" [@detailExpand]="row.testExpande ? 'expanded' : 'collapsed'"></tr>
                                </table>
                                
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-tab>
            <!----------------------  Factures -------------->
            <mat-tab *ngIf="typeAction == '2'" label="Factures">
                <app-avt-listes
                    #listeFactureComponen
                    [showFilter]="false"
                    [listBtn]="listBtnListeFacture"
                    [heightTable]="'400'" 
                    [dataSourceBrut]="[]" 
                    [displayedColumnsBrut]="columnsListeDocument"
                    (btnTable)="clickBtnHeatListeDocument($event,'1')">
                </app-avt-listes>
            </mat-tab>
            <!----------------------  Documents -------------->
            <mat-tab label="Documents">
                <div *ngIf="showDoc">
                    <app-show-tree-doc [param_code]="param_code" [File_Type]="'action'" [typeTrs]="typeTrs">
                    </app-show-tree-doc>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
<!-- menu contectuelle pour calmois -->
 <ng-template #menuContectuelleCalmois let-user>
    <section class="user-menu">
        <ng-container  *ngIf="!disabled">
            <div (click)="verifierEndEnregistrerPlanificationCalmois()">Planifier</div>
            <div *ngIf="typeAction =='2'" (click)="showFrmDuplicationActionPrestatonCalmois(frmDuplicationActionPrestatonCalmois)">Dupliquer</div>
            <div (click)="modifierPlanificationCalmois(frmModifierPlanificationCalmois,'Modification')">Modifier</div>
            <div (click)="modifierPlanificationCalmois(frmSupprimerPlanificationCalmois,'Suppression')">Supprimer</div>
        </ng-container>
        
        <div (click)="closeAllMenuContectuelle()">Quiter</div>
    </section>
</ng-template>

<!-- menu contectuelle pour planification action -->
 <ng-template #menuContectuelleAction let-user>
    <section class="user-menu">
        <ng-container  *ngIf="!disabled">
            <div (click)="planifierAction()">Planifier</div>
            <div (click)="openFrmModifierPlanificationFullCall(frmModifierPlanificationFullCall,'modifier')">Modifier</div>
            <div (click)="supprmierActionD()">Supprimer</div>
            <div (click)="openFrmModifierPlanificationFullCall(frmModifierPlanificationFullCall,'dupliquer')">Dupliquer</div>
            <!-- <div (click)="setIntervalDuplicationActionD(intervalDuplicationAction)">Dupliquer</div> -->

        </ng-container>
        <div (click)="closeAllMenuContectuelle()">Quiter</div>
    </section>
</ng-template>
<ng-template #intervalDuplicationAction>
    <h4>Duplication</h4>

    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px;" class="heightInput">
        <mat-label>Matière</mat-label>
        <mat-select [disabled]="true" name="Matiere_Code2" [ngModel]="selectedMatiereCursus.Matiere_Code" placeholder="Matière" >
            <mat-option *ngFor="let mat of listeMatiereCursus" [value]="mat.Matiere_Code">
                {{mat.matiereName}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px" class="heightInput">
        <mat-label>Ressources Humaines</mat-label>
        <mat-select [disabled]="true" name="PersoMatricule2" [ngModel]="Perso_MatriculeSelectedRessourceHumaines" placeholder="Ressources Humaines">
            <mat-option *ngFor="let ressource of listeRessourcesHumaines" [value]="ressource.Perso_Matricule">
                {{ressource.Perso_Nom}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field     appearance="outline"  style="width: 300px;margin-right: 10px" class="heightInput">
        <mat-label>Salle/Atelier</mat-label>
        <mat-select [disabled]="true" name="sal2" [ngModel]="Machine_SelectedSalle" placeholder="Salle/Atelier">
            <mat-optgroup *ngFor="let group of listeSallesForMatSelect" [label]="group.type">
                <mat-option *ngFor="let salle of group.detail" [value]="salle.Machine_Code">
                    {{salle.Batiment}}&nbsp;
                    <b>N°:</b>{{salle.numPort}}&nbsp;                    
                    <b>Etage:</b>{{salle.etage}}
                </mat-option>
            </mat-optgroup>
        </mat-select>
    </mat-form-field>
    <h4>Intervalle</h4>

    <div class="displayFlex">

        <ng-container *ngFor="let month of listMonth;let i = index">
            <div *ngIf="month.planifiable" [id]="'monthDuplication_'+i" (click)="setListMonthDuplication(month)" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (month.selected ? '' : 'rectengle-arrendi-4')" > &nbsp;{{month.monthName}}&nbsp;</div>
            <ng-container *ngFor="let week of month.listeWeek;let k= index">
                <div *ngIf="!week.haveConflie && !week.notPlanifiable" (click)="setWeekDuplication(week)" [id]="'weekDuplication_'+k" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (!week.selected ? 'rectengle-arrendi-4' : '') + (k == month.listeWeek.length-1 ? ' separateur' : '')">
                    &nbsp;<span style="font-size: 10px">{{week.colSpan}}</span>&nbsp;
                </div>                
            </ng-container>
        </ng-container>                                        
    </div>
    <!-- <mat-form-field     appearance="outline"  style="margin-right: 10px;width: 150px;">
        <input (dateChange)="dateFinDupliquationChange()" matInput name="avtActioeFin"
            #avtActiFin="ngModel" [(ngModel)]="dateFinDupliquation" [matDatepicker]="picker4"
            placeholder="Date fin" required>
        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
        <mat-datepicker #picker4></mat-datepicker>
    </mat-form-field> -->
    <span class="button-row">
        <button style="margin-right: 10px;" (click)="dupliquerAction()" mat-raised-button class="colorGreen">Dupliquer</button>
    </span>
    <span class="button-row">
        <button (click)="closeWindowsDiplication()" mat-raised-button class="colorRed">Annuler</button>
    </span>
</ng-template>
<ng-template #fconfirmDuplicationEnConflie >
    <h4>il y a des dates en conflie: <span style="color: red;" >{{msgErrorDateConflie}}</span> voulez-vous continuer?</h4>
    <span class="button-row">
        <button style="margin-right: 10px;" (click)="verifierNbrHeurMatiereEtenregistrerActionD(actionD,selectedMatiereCursus);closeWindowsDiplication();" mat-raised-button class="colorGreen">Dupliquer</button>
    </span>
    <span class="button-row">
        <button (click)="closeWindowsDiplication()" mat-raised-button class="colorRed">Annuler</button>
    </span>
</ng-template>
<ng-template #frmModifierPlanificationCalmois>
    <div *ngIf="exist;else attente2"></div>
    <ng-template #attente2>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <div class="display-flex-end">
        <button (click)="enregistrerPlanificationForUpdate()" mat-raised-button class="colorGreen separateur">
            <mat-icon>save</mat-icon>
            Enregistrer
        </button>
        <button (click)="closeDialogModifierPlanificationCalmois()" mat-raised-button class="colorRed">
            <mat-icon>close</mat-icon>
            Fermer
        </button>
    </div>
    <div class="btn3">
        <div *ngIf="typeAction == '0' || typeAction == '2'" style="margin-right: 10px;">
            <mat-radio-group *ngIf="typeAction == '0'" (change)="typePresenceActionChangeForUpdate()" name="typePresencexx" [(ngModel)]="selectedTypePresenceForUpdate">
                <div *ngFor="let type of typePresenceAction" >
                    <mat-radio-button [value]="type.avtActionType_Id">{{type.DiverSys_Titre}}</mat-radio-button>
                </div>
            </mat-radio-group>
            <div *ngIf="typeAction == '2'">
                <form class="example-form" #intervaleHeureTypePresence="ngForm">
                    <div >
                        <mat-form-field     appearance="outline"  style="width: 160px;">
                            <mat-label>Intitul&eacute;</mat-label>
                            <input [disabled]="disabled" matInput name="actiIntitule2" #actIntitule2="ngModel"
                                [(ngModel)]="actionDIntitule" placeholder="Intitul&eacute;" required>
                        </mat-form-field>
                        <br>
                        <app-recherche 
                            #collaborateurCalendrierActionForUpdateComponent
                            [required] = "true"
                            [style]="{'width' : '160px'}"
                            [disabled]="disabled" 
                            [api]="generalService.api" 
                            [numColonneToShow]="1" 
                            [numColonneToReturn]="0" 
                            recherche="avtAcollaborateur" 
                            [param]="'0'" 
                            name="name_2" 
                            placeholder="Collaborateurs" >
                        </app-recherche>
                        <br>
                        <mat-form-field     appearance="outline"  style="width: 160px;">
                            <mat-label>Type action</mat-label>
                            <mat-select [disabled]="disabled" name="actioType2" #actioType2="ngModel"
                                [(ngModel)]="typeActionD" placeholder="Type action" required>
                                <mat-option *ngFor="let typeAction of listeTypeAction" [value]="typeAction.avtParamAction_Code">
                                    {{typeAction.avtParamAction_Description}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Matin -->
                    <div style="margin-right: 10px">
                    <mat-checkbox [disabled]="disabled" name="MatinChecked2" [(ngModel)]="MatinTypePresenceChecked" (change)="onMatinTypePresenceChecked()">
                        <h5>Matin</h5>
                    </mat-checkbox>
                    <br>
                    <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                        <mat-label>H.D&eacute;but</mat-label>
                        <input [disabled]="disabled || !MatinTypePresenceChecked" matInput name="typePresence_HeureDebAM2"
                            [matAutocomplete]="auto52" [(ngModel)]="typePresenceHeureDebAM"
                            (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureDebAM')" placeholder="H.D&eacute;but"  [required]="MatinTypePresenceChecked"
                            (input)="timeAMchange($event)">
                        <mat-autocomplete #auto52="matAutocomplete">
                            <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                            {{option}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  style="width: 70px;">
                        <mat-label>H.Fin</mat-label>
                        <input [disabled]="disabled || !MatinTypePresenceChecked" matInput name="typePresence_HeureFinAM2"
                            [matAutocomplete]="auto62" [(ngModel)]="typePresenceHeureFinAM"
                            (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureFinAM')" placeholder="H.Fin"  [required]="MatinTypePresenceChecked"
                            (input)="timeAMchange($event)">
                        <mat-autocomplete #auto62="matAutocomplete">
                            <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                            {{option}}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    </div>
                    <!-- -----apres midi -->
                    <div>
                        <mat-checkbox [disabled]="disabled" name="ApMidiCheckedx2" [(ngModel)]="ApMidiTypePresenceChecked" (change)="onApMidiTypePresenceChecked()">
                            <h5>Apr&egrave;s midi</h5>
                        </mat-checkbox>
                        <br>
                        <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                            <mat-label>H.D&eacute;but</mat-label>
                            <input [disabled]="disabled || !ApMidiTypePresenceChecked" matInput name="typePresence_HeureDebPM2"
                                [matAutocomplete]="auto72" [(ngModel)]="typePresenceHeureDebPM"
                                (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureDebPM')" placeholder="H.D&eacute;but"  [required]="ApMidiTypePresenceChecked"
                                (input)="timePMchange($event)">
                            <mat-autocomplete #auto72="matAutocomplete">
                                <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field     appearance="outline"  style="width: 70px;">
                            <mat-label>H.Fin</mat-label>
                            <input [disabled]="disabled || !ApMidiTypePresenceChecked" matInput name="typePresence_HeureFinPM2"
                                [matAutocomplete]="auto82" [(ngModel)]="typePresenceHeureFinPM"
                                (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureFinPM')" placeholder="H.Fin"  [required]="ApMidiTypePresenceChecked"
                                (input)="timePMchange($event)">
                            <mat-autocomplete #auto82="matAutocomplete">
                                <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </div>
        <div style="width: 500px">
            <app-calendar #calendarModificationActionComponent
            *ngIf="showCalendarActionModification && paramHeure != undefined"
            [showHeader]="true"
            [events]="eventsCalandarModification"
            [selectable]="false" 
            [editable]="true" 
            [paramHeure]="paramHeureCalendar" 
            [intervale]=7 
            [date_Fin]="dateFinModification" 
            [date_Debut]="dateDebutModification" 
            [defaultDate]="dateDebutModification"
            (actionCalendar)="actionCalendar2($event)" >
        </app-calendar>
        </div>
    </div>


</ng-template>
<ng-template #frmSupprimerPlanificationCalmois >
    <mat-card >
        <mat-card-header class="titreFrm">
            <mat-card-title>{{actionPlanification}} de la planification</mat-card-title>
        </mat-card-header>
        <mat-card-content class="border">
            <div class="displayFlex">
                <div>
                    <mat-form-field     appearance="outline"  style="width: 200px;">
                        <mat-label>Planification</mat-label>
                        <mat-select [disabled]="disabled" name="aab" (selectionChange)="onSelectedAvtActionTypeDChange()"
                            [(ngModel)]="selectedAvtActionTypeD" placeholder="Planification">
                            <mat-option *ngFor="let avtActionTypeD of listeAvtActionTypeD" [value]="avtActionTypeD.avtActionTypeD_Id">
                                {{avtActionTypeD["text"]}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- Matin -->
                <div *ngIf="actionPlanification == 'Modification'">
                    <mat-checkbox [disabled]="disabled" name="MatinChecked2" [(ngModel)]="MatinTypePresenceChecked2" (change)="onMatinTypePresenceChecked2()">
                        <h5>Matin</h5>
                    </mat-checkbox>
                    <br>
                    <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                        <mat-label>H.D&eacute;but</mat-label>
                        <input [disabled]="disabled || !MatinTypePresenceChecked2" matInput name="typePresence_HeureDebAM2"
                        [matAutocomplete]="auto5" [(ngModel)]="typePresenceHeureDebAM2"
                        (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureDebAM2')" placeholder="H.D&eacute;but"  [required]="MatinTypePresenceChecked2"
                        (input)="timeAMchange($event)">
                        <mat-autocomplete #auto5="matAutocomplete">
                        <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                            {{option}}
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                
                    <mat-form-field     appearance="outline"  style="width: 70px;">
                        <mat-label>H.Fin</mat-label>
                        <input [disabled]="disabled || !MatinTypePresenceChecked2" matInput name="typePresence_HeureFinAM2"
                        [matAutocomplete]="auto6" [(ngModel)]="typePresenceHeureFinAM2"
                        (blur)="HeureTypePresenceAMBlur($event,'typePresenceHeureFinAM2')" placeholder="H.Fin"  [required]="MatinTypePresenceChecked2"
                        (input)="timeAMchange($event)">
                        <mat-autocomplete #auto6="matAutocomplete">
                        <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                            {{option}}
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <!-- -----apres midi -->
                <div *ngIf="actionPlanification == 'Modification'">
                    <mat-checkbox [disabled]="disabled" name="ApMidiChecked2" [(ngModel)]="ApMidiTypePresenceChecked2" (change)="onApMidiTypePresenceChecked2()">
                        <h5>Apr&egrave;s midi</h5>
                    </mat-checkbox>
                    <br>
                    <mat-form-field     appearance="outline"  style="width: 70px;margin-right: 20px;">
                        <mat-label>H.D&eacute;but</mat-label>
                        <input [disabled]="disabled || !ApMidiTypePresenceChecked2" matInput name="typePresence_HeureDebPM2"
                        [matAutocomplete]="auto7" [(ngModel)]="typePresenceHeureDebPM2"
                        (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureDebPM2')" placeholder="H.D&eacute;but"  [required]="ApMidiTypePresenceChecked2"
                        (input)="timePMchange($event)">
                        <mat-autocomplete #auto7="matAutocomplete">
                        <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                            {{option}}
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  style="width: 70px;">
                        <mat-label>H.Fin</mat-label>
                        <input [disabled]="disabled || !ApMidiTypePresenceChecked2" matInput name="typePresence_HeureFinPM2"
                        [matAutocomplete]="auto8" [(ngModel)]="typePresenceHeureFinPM2"
                        (blur)="HeureTypePresencePMBlur($event,'typePresenceHeureFinPM2')" placeholder="H.Fin"  [required]="ApMidiTypePresenceChecked2"
                        (input)="timePMchange($event)">
                        <mat-autocomplete #auto8="matAutocomplete">
                        <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                            {{option}}
                        </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>    
        </mat-card-content>
        <mat-card-actions  align="end">
            <button [disabled]="!exist" (click)="closeDialogModifierPlanificationCalmois()"  mat-raised-button class="colorRed">
                <mat-icon>close</mat-icon>
                Fermer
            </button>
            <button [disabled]="!exist" (click)="enregistrerModificationPlanificationCalmois('')"  mat-raised-button [ngClass]="actionPlanification =='Modification' ? 'colorGreen' : 'colorRed'">
                <mat-icon>{{actionPlanification =='Modification' ? 'save' : 'delete'}}</mat-icon>
                {{actionPlanification =='Modification' ? 'Enregistrer' : 'Supprimer'}}
            </button>
            <button *ngIf="actionPlanification !='Modification'" [disabled]="!exist" (click)="enregistrerModificationPlanificationCalmois('tous')"  mat-raised-button [ngClass]="actionPlanification =='Modification' ? 'colorGreen' : 'colorRed'">
                <mat-icon>{{actionPlanification =='Modification' ? 'save' : 'delete'}}</mat-icon>
                {{actionPlanification =='Modification' ? 'Enregistrer tous' : 'Supprimer tous'}}
            </button>
        </mat-card-actions>
    </mat-card>
</ng-template>
<ng-template #frmModifierPlanificationFullCall>
    <h4>
        {{titrefrmModifierPlanificationFullCall}}
        <mat-checkbox *ngIf="!disabledFrmModifierPlanificationFullCall" name="azex" [(ngModel)]="aplyChangeToAllPlanification">
            Appliquer le changement à toutes les planifications
        </mat-checkbox>
    </h4>
    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px;" class="heightInput">
        <mat-label>Matière</mat-label>
        <mat-select [disabled]="disabledFrmModifierPlanificationFullCall" name="Matiere_Code3" [(ngModel)]="selectedMatiereCursusForUpdate.Matiere_Code" placeholder="Matière" (selectionChange)="onMatiereChange($event,'selectedMatiereCursusForUpdate')" >
            <mat-option *ngFor="let mat of listeMatiereCursus" [value]="mat.Matiere_Code">
                {{mat.matiereName}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field     appearance="outline"  style="width: 200px;margin-right: 10px" class="heightInput">
        <mat-select [disabled]="disabledFrmModifierPlanificationFullCall" name="PersoMatricule3" [(ngModel)]="Perso_MatriculeSelectedRessourceHumainesForUpdate" placeholder="Ressources Humaines">
            <mat-option *ngFor="let ressource of listeRessourcesHumaines" [value]="ressource.Perso_Matricule">
                {{ressource.Perso_Nom}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field     appearance="outline"  style="width: 300px;margin-right: 10px" class="heightInput">
        <mat-label>Salle/Atelier</mat-label>
        <mat-select [disabled]="disabledFrmModifierPlanificationFullCall" name="sal3" [(ngModel)]="Machine_SelectedSalleForUpdate" placeholder="Salle/Atelier">
            <mat-optgroup *ngFor="let group of listeSallesForMatSelect" [label]="group.type">
                <mat-option *ngFor="let salle of group.detail" [value]="salle.Machine_Code">
                    <b>Port:</b>{{salle.numPort}}&nbsp;
                    <b>Batiment:</b>{{salle.Batiment}}&nbsp;
                    <b>Etage:</b>{{salle.etage}}
                </mat-option>
            </mat-optgroup>
        </mat-select>
    </mat-form-field>
    <div class="displayFlex">
        <div>
            <mat-form-field     appearance="outline"  style="width: 70px;">
                <mat-label>H.D&eacute;but</mat-label>
                <input [disabled]="disabledFrmModifierPlanificationFullCall" matInput name="avtAction_heureDebAM22" #avt_Action_heureDebAM
                  [matAutocomplete]="auto11" [(ngModel)]="heureDebForUpdate"
                  (blur)="ActionHeureAMBlur($event,'this.heureDebForUpdate')" placeholder="H.D&eacute;but"  required="true"
                  (input)="timeAMchange($event)">
                <mat-autocomplete #auto11="matAutocomplete">
                  <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                    {{option}}
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field     appearance="outline"  style="width: 70px;">
                <mat-label>H.Fin</mat-label>
                <input [disabled]="disabledFrmModifierPlanificationFullCall" matInput name="avtAction_heureFinAM11" #avt_Action_heureFinAM
                  [matAutocomplete]="auto22" [(ngModel)]="heureFinForUpdate"
                  (blur)="ActionHeureAMBlur($event,'this.heureFinForUpdate')" placeholder="H.Fin"  required="true"
                  (input)="timeAMchange($event)">
                <mat-autocomplete #auto22="matAutocomplete">
                  <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                    {{option}}
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="disabledFrmModifierPlanificationFullCall">
        <h4>Intervalle</h4>

        <div class="displayFlex">

            <ng-container *ngFor="let month of listMonth;let i = index">
                <div *ngIf="month.planifiable" [id]="'monthDuplication_'+i" (click)="setListMonthDuplication(month)" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (month.selected ? '' : 'rectengle-arrendi-4')" > &nbsp;{{month.monthName}}&nbsp;</div>
                <ng-container *ngFor="let week of month.listeWeek;let k= index">
                    <div *ngIf="!week.haveConflie && !week.notPlanifiable" (click)="setWeekDuplication(week)" [id]="'weekDuplication_'+k" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (!week.selected ? 'rectengle-arrendi-4' : '') + (k == month.listeWeek.length-1 ? ' separateur' : '')">
                        &nbsp;<span style="font-size: 10px">{{week.colSpan}}</span>&nbsp;
                    </div>                
                </ng-container>
            </ng-container>                                        
        </div>        
    </div>

    <div class="display-flex-end">
        <button (click)="closeWindowsDiplication()" mat-raised-button class="colorRed separateur">
            <mat-icon>close</mat-icon>
            Fermer
        </button>
        <button *ngIf="!disabledFrmModifierPlanificationFullCall" [disabled]="!exist" (click)="modifierActionD()" mat-raised-button class="colorGreen">
            <mat-icon>save</mat-icon>
            Appliquer
        </button>
        <button *ngIf="disabledFrmModifierPlanificationFullCall" style="margin-right: 10px;" (click)="dupliquerAction2()" mat-raised-button class="colorGreen">
            <mat-icon>repeat</mat-icon>
            Dupliquer
        </button>
    </div>
</ng-template>
<ng-template #frmBonCommande>
<form  #formBonCommandem="ngForm"> 
    <mat-form-field     appearance="outline"  style="width: 100px;">
        <mat-label>Code</mat-label>
        <input [disabled]="true" matInput name="Doc_Num" #Doc_Num="ngModel"
            [(ngModel)]="bonComamnde.Doc_Num" placeholder="Code">
    </mat-form-field>
    <mat-form-field     appearance="outline"  style="width: 260px;">
        <mat-label>Intitul&eacute;</mat-label>
        <input [disabled]="disabled" matInput name="Doc_Obs" #Doc_Obs="ngModel"
            [(ngModel)]="bonComamnde.Doc_Obs" placeholder="Intitul&eacute;" required>
    </mat-form-field>
    <br>
    <mat-form-field     appearance="outline"  style="width: 130px;">
        <mat-label>Date début</mat-label>
        <input  [disabled]="disabled" matInput name="DateDebut"
            #DateDebut="ngModel" [(ngModel)]="bonComamnde.DateDebut" [matDatepicker]="picker11"
            placeholder="Date début" required>
        <mat-datepicker-toggle matSuffix [for]="picker11"></mat-datepicker-toggle>
        <mat-datepicker #picker11></mat-datepicker>
    </mat-form-field>
    <mat-form-field     appearance="outline"  style="width: 130px;">
        <mat-label>Date fin</mat-label>
        <input [disabled]="disabled" matInput name="DateFin"
            #DateFin="ngModel" [(ngModel)]="bonComamnde.DateFin" [matDatepicker]="picker22"
            placeholder="Date fin" required>
        <mat-datepicker-toggle matSuffix [for]="picker22"></mat-datepicker-toggle>
        <mat-datepicker #picker22></mat-datepicker>
    </mat-form-field>
    <mat-form-field     appearance="outline"  style="width:90px;">
        <mat-label>Montant</mat-label>
        <input type="number" [disabled]="disabled" matInput name="Doc_THT" #Doc_THT="ngModel"
            [(ngModel)]="bonComamnde.Doc_THT" placeholder="montant" required>
    </mat-form-field>
    <br>
    <input type="file" (change)="onChangeImagefile($event)">
    <div style="margin-top: 10px;" class="btn1">
        <button (click)="closeFrmBonCommande()" mat-raised-button class="colorRed">Annuler</button>
        <button [disabled]="!exist"(click)="enregistrerFileEndBonCommande()" mat-raised-button class="colorGreen">Enregistrer</button>
    </div>
</form>
</ng-template>
<ng-template #frmDuplicationActionPrestatonCalmois>
    <h4>Duplication action</h4>
   
    <div>
        <h4>Intervalle</h4>

        <div class="displayFlex">

            <ng-container *ngFor="let month of listMonth;let i = index">
                <div [id]="'monthDuplication_'+i" (click)="setListMonthDuplication(month)" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (month.selected ? '' : 'rectengle-arrendi-4')" >
                     &nbsp;{{month.monthName}}&nbsp;
                </div>
                <ng-container *ngFor="let week of month.listeWeek;let k= index">
                    <div *ngIf="!week.haveConflie && !week.notPlanifiable" (click)="setWeekDuplication(week)" [id]="'weekDuplication_'+k" [ngClass]="'rectengle-arrendi margin-bottom-20 ' + (!week.selected ? 'rectengle-arrendi-4' : '') + (k == month.listeWeek.length-1 ? ' separateur' : '')">
                        &nbsp;<span style="font-size: 10px">{{week.colSpan}}</span>&nbsp;
                    </div>                
                </ng-container>
            </ng-container>                                        
        </div>        
    </div>

    <div class="display-flex-end">
        <button (click)="closeWindowsDiplication()" mat-raised-button class="colorRed separateur">
            <mat-icon>close</mat-icon>
            Fermer
        </button>
        <button style="margin-right: 10px;" (click)="dupliquerActionPrestation()" mat-raised-button class="colorGreen">
            <mat-icon>repeat</mat-icon>
            Dupliquer
        </button>
    </div>
</ng-template>
<!-- ne pas supprimer -->
<input id="hiddenBtnForActualiserListe" (click)="doNotThink()" type="submit" style="display: none;" value="aa">